import React from 'react';

const LoadingOverlay = ({ show = false, message = 'Loading...' }) => {
  if (!show) return null; // Jika tidak perlu tampil, jangan render apa pun

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(2px)', // sedikit blur agar lebih halus
      }}
    >
      <div
        className="spinner-border text-primary"
        role="status"
        style={{ width: '3rem', height: '3rem' }}
      >
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="mt-3 text-primary fw-semibold">{message}</p>
    </div>
  );
};

export default LoadingOverlay;
